import React from "react";

const ButtonCancel = ({ textButton, onClick, type, style, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={disabled ? "button-disabled" : "button-cancel"}
      type={type}
      style={style}>
      {textButton}
    </button>
  );
};

export default ButtonCancel;
